var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1025 37.1888C54.2009 47.7821 63.3955 51.3073 63.4974 51.3522C63.4197 51.6007 62.0283 56.3757 58.6532 61.308C55.7355 65.5724 52.7076 69.8209 47.9375 69.9089C43.2504 69.9953 41.7433 67.1296 36.3846 67.1296C31.0276 67.1296 29.353 69.821 24.9162 69.9954C20.3119 70.1697 16.8056 65.3843 13.8639 61.1356C7.85264 52.4448 3.2588 36.5777 9.42717 25.8671C12.4915 20.5482 17.9676 17.1801 23.9115 17.0937C28.4329 17.0074 32.7003 20.1355 35.4644 20.1355C38.2267 20.1355 43.4127 16.3737 48.8646 16.9262C51.1469 17.0212 57.5537 17.8481 61.6674 23.8698C61.3359 24.0752 54.023 28.3325 54.1025 37.1888ZM45.2937 11.1766C47.7381 8.21761 49.3834 4.09849 48.9346 0C45.411 0.141616 41.1503 2.34798 38.623 5.30529C36.358 7.92413 34.3744 12.1157 34.9096 16.1331C38.837 16.437 42.8491 14.1374 45.2937 11.1766Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.a086955d0f477258df164a2c8c415f28.svg";
export { ForwardRef as ReactComponent };